import { render } from "./StripePaymentSuccess.vue?vue&type=template&id=0cd34b7a&ts=true"
import script from "./StripePaymentSuccess.vue?vue&type=script&lang=ts"
export * from "./StripePaymentSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__